/* Portado VERBATIM desde boston_ia/index.html — logica original respetada.
   Fuente: C:\\xampp\\htdocs\\boston_ia\\index.html */
import { state } from './store'

class SabreWebGateway {
  constructor(cfg) { this.cfg = cfg; }
  async executeCommand(command) {
    const startedAt = Date.now();
    let result;
    if (this.cfg.mode === 'embedded') result = await this._ngv(command,startedAt);
    else result = await this._boston(command,startedAt);
    this.cfg.onCommand?.(result);
    return result;
  }
  async _ngv(command,startedAt) {
    try {
      const sdk = window.sabreSdk;
      const svc = sdk?.getService?.(sdk.ICommandMessageService);
      if (!svc) throw new Error('SDK NGV no encontrado en window.sabreSdk');
      const rs = await svc.send({rq:command,showRq:false,showRs:false,showErrors:false});
      const messages = rs.Status?.Messages ?? [];
      return {
        command, success:!!rs.Status?.Success,
        responseText:messages.filter(m=>m.Type==='TEXTRS'||!m.Type).map(m=>m.Text).join('\n'),
        messages, executedAt:new Date(startedAt), durationMs:Date.now()-startedAt
      };
    } catch (err) {
      return { command, success:false, responseText:`ERROR NGV: ${err.message}`,
        messages:[], executedAt:new Date(startedAt), durationMs:Date.now()-startedAt };
    }
  }
  async _boston(command,startedAt) {
    const c = this.cfg.standalone;
    if (!c) throw new Error('Standalone mode requiere config Boston.');
    const url = c.bostonApi.replace(/\/$/,'') + '/sabre/executeCommand?command=' + encodeURIComponent(command);
    try {
      // Headers correctos para las APIs Sabre: token + x-api-key
      const headers = { 'Content-Type': 'application/json', 'x-api-key': c.bostonAkey };
      if (state.sessionToken) headers['token'] = state.sessionToken;
      const resp = await fetch(url, { method:'GET', headers });
      const body = await resp.text();
      return { command, success:resp.ok, responseText:body,
        messages:[], executedAt:new Date(startedAt), durationMs:Date.now()-startedAt };
    } catch (err) {
      return { command, success:false, responseText:`ERROR red: ${err.message}`,
        messages:[], executedAt:new Date(startedAt), durationMs:Date.now()-startedAt };
    }
  }
}

export function makeGateway() {
  return new SabreWebGateway({
    mode: state.config.mode,
    standalone: { bostonApi: state.config.bostonApi, bostonAkey: state.config.bostonAkey },
  })
}

export function ensureGateway() {
  if (!state.gateway) state.gateway = makeGateway()
  return state.gateway
}

export function refreshGateway() {
  state.gateway = makeGateway()
  return state.gateway
}

export { SabreWebGateway }
